import { useEffect, useState } from "react";
import { Award, Download } from "lucide-react";
import {
  listMyCertificates,
  type MyCertificateOut,
} from "../api/certificates";
import { formatMoscowDate } from "../utils/datetime";

export function MyCertificatesSection() {
  const [items, setItems] = useState<MyCertificateOut[] | null>(null);

  useEffect(() => {
    void listMyCertificates()
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  if (items === null) {
    return (
      <section className="card mt-4 p-5">
        <div className="h-3 w-32 animate-pulse rounded bg-surface-alt" />
        <div className="mt-3 h-16 animate-pulse rounded-lg bg-surface-alt" />
      </section>
    );
  }
  if (items.length === 0) {
    return null;
  }

  return (
    <section className="card mt-4 p-5">
      <div className="flex items-center gap-2">
        <Award size={16} strokeWidth={2} className="text-brand-ochre" />
        <h2 className="text-xs font-semibold uppercase tracking-wide text-ink-muted">
          Мои сертификаты
        </h2>
      </div>
      <ul className="mt-3 space-y-2">
        {items.map((c) => (
          <li key={c.completion_id}>
            <a
              href={c.pdf_url}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-3 rounded-lg bg-surface-alt/40 px-3 py-2.5 transition hover:bg-surface-alt"
            >
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand-ochre/15 text-brand-ochre">
                <Award size={16} strokeWidth={2.25} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium text-ink group-hover:text-brand">
                  {c.course_title}
                </div>
                <div className="mt-0.5 flex items-center gap-2 text-[11px] text-ink-muted">
                  <span className="font-mono">{c.reg_number}</span>
                  <span>·</span>
                  <span>
                    {formatMoscowDate(c.completed_at)}
                  </span>
                </div>
              </div>
              <Download
                size={14}
                strokeWidth={2}
                className="shrink-0 text-ink-muted transition group-hover:text-brand"
              />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
